/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AwardWalletAuthUrlResponse
 */
export interface AwardWalletAuthUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof AwardWalletAuthUrlResponse
     */
    url: string;
}

/**
 * Check if a given object implements the AwardWalletAuthUrlResponse interface.
 */
export function instanceOfAwardWalletAuthUrlResponse(value: object): value is AwardWalletAuthUrlResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function AwardWalletAuthUrlResponseFromJSON(json: any): AwardWalletAuthUrlResponse {
    return AwardWalletAuthUrlResponseFromJSONTyped(json, false);
}

export function AwardWalletAuthUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwardWalletAuthUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function AwardWalletAuthUrlResponseToJSON(json: any): AwardWalletAuthUrlResponse {
    return AwardWalletAuthUrlResponseToJSONTyped(json, false);
}

export function AwardWalletAuthUrlResponseToJSONTyped(value?: AwardWalletAuthUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

